export enum UserRoles {
    User = 'User',
    /** Partner-club coach flagged by the Saideline team: unlimited generation, no subscription needed. */
    Premium = 'Premium',
    Admin = 'Admin',
    Owner = 'Owner',
}
